<template>
  <div>
    <div style="position: relative;min-height: 200px">
      <v-container>
        <div v-if="loading" class="text-xs-center">
          <v-progress-circular :size="70" color="primary" indeterminate></v-progress-circular>
        </div>
        <template v-else>
          <v-text-field
            name="Search"
            label="Search"
            v-model="search"
            clearable
            single-line
            prepend-inner-icon="search"
            @keyup="onSearch"
            @blur="onSearch"
            outline
          ></v-text-field>
          <div class="text-xs-center my-2">
            <v-pagination v-model="page" :length="totalPage"></v-pagination>
          </div>
          <template v-for="variable in filterVariable">
            <div class="z-border-red mb-2 pa-2" :key="variable.id">
              <add-variable
                :value="variable"
                type="global"
                @onSave="onEdit"
                @onDelete="onDelete(variable.id)"
              ></add-variable>
            </div>
          </template>
          <div class="text-xs-center my-2">
            <v-pagination v-model="page" :length="totalPage"></v-pagination>
          </div>
          <template v-if="$store.state.superadmin.includes($store.state.userid)">
            <div
              class="add-conversation text-xs-center"
              style="cursor: pointer"
              @click="isAdd = true"
              v-if="!isAdd"
            >
              <i class="fa fa-plus middle"></i>
              {{ $t('Add global variable') }}
            </div>
            <div class="z-border-red mb-2 pa-2" v-else>
              <add-variable @onCancel="isAdd = false" type="global" @onSave="onSave"></add-variable>
            </div>
          </template>
        </template>
      </v-container>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import AddVariable from './AddVariable'
export default {
  data() {
    return {
      isAdd: false,
      loading: true,
      search: '',
      rowsPerPage: 10,
      page: 1
    }
  },
  components: {
    AddVariable
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      flows: 'getFlowList',
      loadingFlowList: 'getLoadingFlowList',
      variable: 'getVariableList',
      loadingVariableList: 'getLoadingVariableList'
    }),
    globalVariable() {
      let filter = this.variable
        ? this.variable.filter(el => {
            return el.flowid == 0
          })
        : []

      if (this.search) {
        filter = filter.filter(el => {
          return el.name && el.name.toLowerCase().includes(this.search.toLowerCase())
        })
      }
      return filter
    },

    filterVariable() {
      var vm = this
      if (vm.variable) {
        let filter = vm.globalVariable

        if (this.rowsPerPage > 0) {
          filter = filter.slice((this.page - 1) * this.rowsPerPage, this.page * this.rowsPerPage)
        }
        return filter
      } else {
        return []
      }
    },
    totalPage() {
      return Math.ceil(this.globalVariable.length / this.rowsPerPage)
    }
  },
  mounted() {
    this.loading = false
  },
  methods: {
    onSearch() {
      this.page = 1
    },
    onEdit(payload) {
      var vm = this
      this.isAdd = false
      vm.loading = true
      var data = payload
      api.editVariable(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadAllVariable').then(() => {
          vm.loading = false
        })
      })
    },
    onSave(payload) {
      var vm = this
      this.isAdd = false
      vm.loading = true
      var data = payload
      api.addVariable(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loading = false
          return
        }
        vm.$store.dispatch('loadAllVariable').then(() => {
          vm.loading = false
        })
      })
    },
    onDelete(id) {
      var vm = this
      var data = {
        id: id
      }
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete this?'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            vm.loading = true
            api.deleteVariable(data, function(error, response) {
              if (error) {
                console.error(error)
                vm.loading = false
                return
              }
              vm.$store.dispatch('loadAllVariable').then(() => {
                vm.loading = false
              })
            })
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/flow/GlobalVariableSetting.vue